export const deleteObject = (objectNameArr, beforeObject, afterObject) => {
  const cleanBefore = { ...beforeObject };
  const cleanAfter = { ...afterObject };


  
  for (let i = 0; i < objectNameArr.length; i++) {
    const objectName = objectNameArr[i];
    delete cleanBefore[objectName];
    delete cleanAfter[objectName];
  }
  
  delete cleanBefore.undefined;
  delete cleanAfter.undefined;

  return { beforeObject: cleanBefore, afterObject: cleanAfter };
};

export default deleteObject;